import { useParams } from 'react-router-dom'
import { StatCard, CardLabel, CardValue, CardUnit, CardSub, ProgressBar, Divider, SubRow, SubStat, SubStatValue, SubStatLabel } from './StatCard'
import useBotBalance from '../../../hooks/useBotBalance'
import useSmartVault from '../../../hooks/useSmartVault'
import { formatTokenAmount } from '../../../utils/math-utils'
import { compareAddresses } from '../../../utils/web3-utils'
import { RELAYER } from '../../../constants/playerAddress'
import { ChainStatsResponse } from '../../../types/API'
import { RELAYER_GAUGES } from '../../../constants/networks'

export interface BotData {
  chainInfo?: ChainStatsResponse
  chainId: number
}

export default function Relayer({ chainId, chainInfo }: BotData) {
  const params = useParams()
  const smartVault = useSmartVault(params.id!, chainId)
  const { data: balance } = useBotBalance(chainId)

  if (!smartVault?.data?.smartVaults) return <StatCard />

  const gauge = RELAYER_GAUGES[chainId]
  const vaults = smartVault.data.smartVaults

  return (
    <StatCard>
      <CardLabel>Relayer Balance</CardLabel>
      {vaults.map((item, i) => {
        const relayerConfigs = item.relayerConfigs || []
        const config = relayerConfigs.find((c) => compareAddresses(c.relayer.id, RELAYER))
        const relayerBalance = Number(
          formatTokenAmount(config?.balance, config?.nativeToken?.decimals, { digits: 2 })
        )
        const ok = gauge ? relayerBalance >= gauge.minVal : true
        const percent = gauge ? (relayerBalance * 100) / gauge.maxVal : 0
        const remainingTx =
          balance?.price && chainInfo?.averageTxCost
            ? ((relayerBalance * Number(balance.price)) / (chainInfo.averageTxCost || 1)).toFixed(0)
            : null

        return (
          <div key={i}>
            <CardValue>
              {relayerBalance}
              <CardUnit>{config?.nativeToken?.symbol}</CardUnit>
            </CardValue>
            <CardSub>Relayer deposit</CardSub>
            <ProgressBar percent={Math.min(percent, 100)} ok={ok} />
            {remainingTx && (
              <>
                <Divider />
                <SubRow>
                  <SubStat>
                    <SubStatValue>{remainingTx}</SubStatValue>
                    <SubStatLabel>Remaining tx</SubStatLabel>
                  </SubStat>
                </SubRow>
              </>
            )}
          </div>
        )
      })}
    </StatCard>
  )
}
